import React from 'react';
import Bg from '../../../Assets/Backgrounds/androidBg.webp';
import AppsBanner from '../../Shared/AppsBanner/AppsBanner';
import {ReactComponent as Btn1} from '../../../Assets/Icons/padBanner.svg';

const Banner=()=>{
    return(
        <>
        <AppsBanner
        title="Securely manage your files and collaborate with everyone from anywhere."
        backgroundImage = {Bg}
        btn1={<Btn1 />}
        />
        </>
    )
};
export default Banner ;